import { BedIcon } from '@phosphor-icons/react';
import { hotelProgramByName, type LoyaltyProgram } from '@voll-intelligence/domain';
import { useGenUiConfig } from '../../../../shared/ui/config.js';
import { CatalogProgramMark, CheckoutLoyaltyLine } from '../checkout_loyalty.js';
import type { HotelCheckoutItem } from './checkout_stay.js';

/** Os programas dos hotéis do card, um por programa, pela marca no nome do hotel
 *  (`hotelProgramByName`): a busca não traz a rede (#6159). Hotel sem marca
 *  conhecida não tem linha. */
function hotelLoyaltyPrograms(items: readonly HotelCheckoutItem[]): LoyaltyProgram[] {
  const programs = new Map<string, LoyaltyProgram>();
  for (const { detail } of items) {
    const program = detail.hotelName ? hotelProgramByName(detail.hotelName) : undefined;
    if (program && !programs.has(program.id)) programs.set(program.id, program);
  }
  return [...programs.values()];
}

/** A linha de fidelidade do card de hotel (#6159), com as regras da do aéreo:
 *  só com o port que lê os programas de hotel e com quem está logado viajando
 *  sozinho. */
export function HotelCheckoutLoyalty({
  items,
  self,
  record,
}: {
  readonly items: readonly HotelCheckoutItem[];
  /** O único viajante é quem está logado. */
  readonly self: boolean;
  readonly record: boolean;
}) {
  const port = useGenUiConfig().loyalty;
  if (!port?.useHotelPlans || !self) return null;
  const { logoOf } = port;
  return (
    <CheckoutLoyaltyLine
      programs={hotelLoyaltyPrograms(items)}
      usePlans={port.useHotelPlans}
      record={record}
      appliedKey="productCheckout.loyalty.appliedProgram"
      onAdd={port.openAdd}
      renderMark={(program) => (
        <CatalogProgramMark logo={logoOf?.(program.id) ?? null} icon={<BedIcon />} />
      )}
    />
  );
}
